export default __webpack_public_path__ + "static/media/A_arte_do_novo.0be00712.jpg";